import { logError } from '@zg-rentals/log-error';
import type { SyntheticEvent } from 'react';

/**
 * @file
 * Until all rentals-js apps are using the latest from page-frame-service
 * we have to manually attach the "cookie preference" handler.
 * This module exports a method `onPageFrameLinkClick` which should be added
 * as the `onLinkClick` prop to the "PageFooter" component from page-frame.
 */

const DATAGRAIL_ERROR_TYPE_PREFIX = 'DataGrailError';
const COOKIE_PREFERENCE_CLASS_NAME = 'cookie-preference';

function showConsentBanner(_event?: MouseEvent) {
  try {
    if (
      'DG_BANNER_API' in window &&
      typeof window.DG_BANNER_API === 'object' &&
      window.DG_BANNER_API !== null &&
      'showLayer' in window.DG_BANNER_API &&
      typeof window.DG_BANNER_API.showLayer === 'function'
    ) {
      window.DG_BANNER_API.showLayer('categories-layer');
    }
  } catch (error) {
    logError({
      error,
      errorType: `${DATAGRAIL_ERROR_TYPE_PREFIX}__ShowConsentBanner`,
      context: 'Failed to open Datagrail consent banner',
    });
  }
}

// it is recommended that all apps use the page frame service, not the components directly but...
// for apps that aren't using page frame service, ie, using the PageFooter component directly
// they should use this for the `onLinkClick` prop
export function onPageFrameLinkClick(event: SyntheticEvent) {
  const target = event?.target;
  if (
    target != null &&
    'classList' in target &&
    target.classList !== null &&
    typeof target.classList === 'object' &&
    'value' in target.classList &&
    typeof target.classList.value === 'string' &&
    target.classList.value.includes(COOKIE_PREFERENCE_CLASS_NAME)
  ) {
    showConsentBanner();
  }
}
